import type {FuncaoMenuV2} from './menu-v2.catalogo';

/** Funções verificadas em abas, formulários e diálogos; herdam o acesso da página. */
export const FUNCOES_INTERNAS_MENU_V2: (Omit<FuncaoMenuV2, 'grupo' | 'secao' | 'pagina' | 'peso'> & {
  paginaId: string;
  recurso?: string;
})[] = [
  {
    "paginaId": "loja/tab/fotos", "id": "funcao-logo",
    "nome": "Logo", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-image", "termos": "visual da loja",
    "nomesAlternativos": ["Trocar logo", "Alterar logotipo", "Mudar logo da loja"]
  },
  {
    "paginaId": "loja/tab/fotos", "id": "funcao-capa",
    "nome": "Capa", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-image", "termos": "visual da loja",
    "nomesAlternativos": ["Trocar a capa", "Mudar imagem de capa", "Alterar capa do cardápio"]
  },
  {
    "paginaId": "loja/tab/fotos", "id": "funcao-favicon",
    "nome": "Favicon", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-image", "termos": "visual da loja",
    "nomesAlternativos": ["Ícone da aba do navegador"]
  },
  {
    "paginaId": "banner", "id": "funcao-ordenar-banners",
    "nome": "Ordenar banners", "descricao": "Selecione um banner para editar esta opção.",
    "icone": "fe-image", "termos": "banners",
    "nomesAlternativos": ["Mudar ordem dos banners", "Reorganizar banners"]
  },
  {
    "paginaId": "banner", "id": "funcao-validade-do-banner",
    "nome": "Validade do banner", "descricao": "Selecione um banner para editar esta opção.",
    "icone": "fe-image", "termos": "banners",
    "nomesAlternativos": ["Programar validade do banner", "Quando o banner expira"]
  },
  {
    "paginaId": "banner", "id": "funcao-link-do-banner",
    "nome": "Link do banner", "descricao": "Selecione um banner para editar esta opção.",
    "icone": "fe-image", "termos": "banners",
    "nomesAlternativos": ["Alterar link do banner", "Clique no banner"]
  },
  {
    "paginaId": "banner", "id": "funcao-produtos-do-banner",
    "nome": "Produtos do banner", "descricao": "Selecione um banner para editar esta opção.",
    "icone": "fe-image", "termos": "banners",
    "nomesAlternativos": ["Vincular produtos ao banner"]
  },
  {
    "paginaId": "fiscal", "id": "funcao-certificado-a1",
    "nome": "Certificado A1", "descricao": "Abra Configurações na tela fiscal e localize esta opção.",
    "icone": "fe-file-text", "termos": "fiscal",
    "nomesAlternativos": ["Certificado digital", "Renovar certificado", "Enviar certificado A1"]
  },
  {
    "paginaId": "fiscal", "id": "funcao-csc",
    "nome": "CSC", "descricao": "Abra Configurações na tela fiscal e localize esta opção.",
    "icone": "fe-file-text", "termos": "fiscal",
    "nomesAlternativos": ["Código de segurança do contribuinte", "Configurar CSC"]
  },
  {
    "paginaId": "fiscal", "id": "funcao-regime-tributario",
    "nome": "Regime tributário", "descricao": "Abra Configurações na tela fiscal e localize esta opção.",
    "icone": "fe-file-text", "termos": "fiscal",
    "nomesAlternativos": []
  },
  {
    "paginaId": "fiscal", "id": "funcao-serie-da-nota",
    "nome": "Série da nota", "descricao": "Abra Configurações na tela fiscal e localize esta opção.",
    "icone": "fe-file-text", "termos": "fiscal",
    "nomesAlternativos": []
  },
  {
    "paginaId": "fiscal", "id": "funcao-tributacao-de-producao-propria",
    "nome": "Tributação de produção própria", "descricao": "Abra Configurações na tela fiscal e localize esta opção.",
    "icone": "fe-file-text", "termos": "fiscal",
    "nomesAlternativos": []
  },
  {
    "paginaId": "fiscal", "id": "funcao-tributacao-de-terceiros",
    "nome": "Tributação de terceiros", "descricao": "Abra Configurações na tela fiscal e localize esta opção.",
    "icone": "fe-file-text", "termos": "fiscal",
    "nomesAlternativos": []
  },
  {
    "paginaId": "meupdv", "id": "funcao-caixa-online",
    "nome": "Caixa online", "descricao": "Abra a aba Caixa online.",
    "icone": "fe-dollar-sign", "termos": "caixa",
    "nomesAlternativos": []
  },
  {
    "paginaId": "meupdv", "id": "funcao-historico-de-caixa",
    "nome": "Histórico de caixa", "descricao": "Abra a aba Histórico de caixa.",
    "icone": "fe-dollar-sign", "termos": "caixa",
    "nomesAlternativos": []
  },
  {
    "paginaId": "meupdv", "id": "funcao-consolidado-de-caixa",
    "nome": "Consolidado de caixa", "descricao": "Abra a aba Consolidado de caixa.",
    "icone": "fe-dollar-sign", "termos": "caixa",
    "nomesAlternativos": []
  },
  {
    "paginaId": "meupdv", "id": "funcao-historico-de-sangrias",
    "nome": "Histórico de sangrias", "descricao": "Abra a aba Sangrias.",
    "icone": "fe-dollar-sign", "termos": "caixa",
    "nomesAlternativos": []
  },
  {
    "paginaId": "loja/tab/caixa", "id": "funcao-caixa-por-operador",
    "nome": "Caixa por operador", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-dollar-sign", "termos": "caixa",
    "nomesAlternativos": ["Caixa individual", "Um caixa para cada operador"]
  },
  {
    "paginaId": "comissionamento", "id": "funcao-cadastrar-comissao",
    "nome": "Cadastrar comissão", "descricao": "Abra o cadastro correspondente na tela de comissões.",
    "icone": "fe-percent", "termos": "comissões",
    "nomesAlternativos": []
  },
  {
    "paginaId": "comissionamento", "id": "funcao-cadastrar-comissionado",
    "nome": "Cadastrar comissionado", "descricao": "Abra o cadastro correspondente na tela de comissões.",
    "icone": "fe-percent", "termos": "comissões",
    "nomesAlternativos": []
  },
  {
    "paginaId": "comissionamento", "id": "funcao-relatorio-de-comissoes",
    "nome": "Relatório de comissões", "descricao": "Abra a aba correspondente nesta página.",
    "icone": "fe-percent", "termos": "comissões",
    "nomesAlternativos": []
  },
  {
    "paginaId": "comissionamento", "id": "funcao-nome-dos-comissionados",
    "nome": "Nome dos comissionados", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-percent", "termos": "comissões",
    "nomesAlternativos": []
  },
  {
    "paginaId": "loja/tab/cardapio", "id": "funcao-cardapio-so-para-consulta",
    "nome": "Cardápio só para consulta", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-book-open", "termos": "cardápio",
    "nomesAlternativos": ["Cardápio sem pedidos", "Modo visualização"]
  },
  {
    "paginaId": "loja/tab/cardapio", "id": "funcao-mostrar-produtos-indisponiveis",
    "nome": "Mostrar produtos indisponíveis", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-book-open", "termos": "cardápio",
    "nomesAlternativos": ["Exibir produtos esgotados", "Ocultar produtos indisponíveis"]
  },
  {
    "paginaId": "loja/tab/cardapio", "id": "funcao-limitar-produtos-por-pedido",
    "nome": "Limitar produtos por pedido", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-book-open", "termos": "cardápio",
    "nomesAlternativos": ["Máximo de itens por pedido"]
  },
  {
    "paginaId": "mesas/configuracoes", "id": "funcao-taxa-de-servico",
    "nome": "Taxa de serviço", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-grid", "termos": "mesas",
    "nomesAlternativos": ["10% do garçom", "Dez por cento do garçom", "Configurar taxa de serviço"]
  },
  {
    "paginaId": "mesas/configuracoes", "id": "funcao-varias-comandas-por-mesa",
    "nome": "Várias comandas por mesa", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-grid", "termos": "mesas",
    "nomesAlternativos": ["Múltiplas comandas por mesa", "Separar comandas"]
  },
  {
    "paginaId": "mesas/configuracoes", "id": "funcao-chamar-garcom",
    "nome": "Chamar garçom", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-grid", "termos": "mesas",
    "nomesAlternativos": ["Aviso para chamar garçom", "Solicitar fechamento de mesa"]
  },
  {
    "paginaId": "mesas/configuracoes", "id": "funcao-exigir-cartao-nas-mesas",
    "nome": "Exigir cartão nas mesas", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-grid", "termos": "mesas",
    "nomesAlternativos": []
  },
  {
    "paginaId": "loja/tab/fidelidade", "id": "funcao-cashback",
    "nome": "Cashback", "descricao": "Abra as regras de fidelidade; as opções dependem do plano e da integração ativa.",
    "icone": "fe-gift", "termos": "fidelidade",
    "nomesAlternativos": ["Configurar cashback", "Dinheiro de volta"]
  },
  {
    "paginaId": "loja/tab/fidelidade", "id": "funcao-pontos-por-pedido",
    "nome": "Pontos por pedido", "descricao": "Abra as regras de fidelidade; as opções dependem do plano e da integração ativa.",
    "icone": "fe-gift", "termos": "fidelidade",
    "nomesAlternativos": ["Configurar pontuação por pedido", "Selos por pedido"]
  },
  {
    "paginaId": "loja/tab/fidelidade", "id": "funcao-resgatar-brindes-no-cardapio",
    "nome": "Resgatar brindes no cardápio", "descricao": "Abra as regras de fidelidade; as opções dependem do plano e da integração ativa.",
    "icone": "fe-gift", "termos": "fidelidade",
    "nomesAlternativos": []
  },
  {
    "paginaId": "loja/tab/fidelidade", "id": "funcao-pontuar-mesas",
    "nome": "Pontuar mesas", "descricao": "Abra as regras de fidelidade; as opções dependem do plano e da integração ativa.",
    "icone": "fe-gift", "termos": "fidelidade",
    "nomesAlternativos": []
  },
  {
    "paginaId": "chatbot/configuracoes", "id": "funcao-nome-da-atendente",
    "nome": "Nome da atendente", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-message-circle", "termos": "mia",
    "nomesAlternativos": ["Mudar nome da MIA", "Trocar nome da atendente"]
  },
  {
    "paginaId": "chatbot/configuracoes", "id": "funcao-passar-para-atendente-humano",
    "nome": "Passar para atendente humano", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-message-circle", "termos": "mia",
    "nomesAlternativos": ["Transferir para humano", "MIA chamar uma pessoa"]
  },
  {
    "paginaId": "chatbot/configuracoes", "id": "funcao-tempo-de-pausa",
    "nome": "Tempo de pausa", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-message-circle", "termos": "mia",
    "nomesAlternativos": ["Pausar MIA durante atendimento humano"]
  },
  {
    "paginaId": "chatbot/configuracoes", "id": "funcao-sugerir-produto-extra",
    "nome": "Sugerir produto extra", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-message-circle", "termos": "mia",
    "nomesAlternativos": ["Oferecer um item a mais", "Upsell"]
  },
  {
    "paginaId": "chatbot/configuracoes", "id": "funcao-lembretes-proativos",
    "nome": "Lembretes proativos", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-message-circle", "termos": "mia",
    "nomesAlternativos": ["Follow-up da MIA", "Lembrar cliente de finalizar"]
  },
  {
    "paginaId": "chatbot/configuracoes", "id": "funcao-instrucoes-da-loja",
    "nome": "Instruções da loja", "descricao": "Na aba MIA V3, localize Instruções da loja (administração interna).",
    "icone": "fe-message-circle", "termos": "mia",
    "nomesAlternativos": [], "interna": true
  },
  {
    "paginaId": "loja/formaspagamento/offline", "id": "funcao-desconto-por-forma-de-pagamento",
    "nome": "Desconto por forma de pagamento", "descricao": "Selecione a forma de pagamento e edite suas regras.",
    "icone": "fe-credit-card", "termos": "pagamentos",
    "nomesAlternativos": ["Desconto no Pix", "Desconto no dinheiro"]
  },
  {
    "paginaId": "loja/formaspagamento/offline", "id": "funcao-taxa-de-retorno-no-pagamento",
    "nome": "Taxa de retorno no pagamento", "descricao": "Selecione a forma de pagamento e edite suas regras.",
    "icone": "fe-credit-card", "termos": "pagamentos",
    "nomesAlternativos": []
  },
  {
    "paginaId": "loja/tab/impressao", "id": "funcao-imprimir-automaticamente",
    "nome": "Imprimir automaticamente", "descricao": "Selecione uma impressora e abra suas configurações.",
    "icone": "fe-printer", "termos": "impressão",
    "nomesAlternativos": ["Imprimir sozinho", "Impressão automática"]
  },
  {
    "paginaId": "loja/tab/impressao", "id": "funcao-tamanho-do-papel",
    "nome": "Tamanho do papel", "descricao": "Selecione uma impressora e abra suas configurações.",
    "icone": "fe-printer", "termos": "impressão",
    "nomesAlternativos": ["Papel 58mm", "Papel 80mm", "Largura da bobina"]
  },
  {
    "paginaId": "loja/tab/impressao", "id": "funcao-personalizar-comprovante",
    "nome": "Personalizar comprovante", "descricao": "Selecione uma impressora e abra suas configurações.",
    "icone": "fe-printer", "termos": "impressão",
    "nomesAlternativos": ["Campos do comprovante", "Layout da impressão"]
  },
  {
    "paginaId": "loja/tab/impressao", "id": "funcao-corte-do-papel",
    "nome": "Corte do papel", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-printer", "termos": "impressão",
    "nomesAlternativos": ["Cortar papel automaticamente", "Guilhotina"]
  },
  {
    "paginaId": "loja/tab/impressao", "id": "funcao-areas-de-destino",
    "nome": "Áreas de destino", "descricao": "Abra a aba correspondente nesta página.",
    "icone": "fe-monitor", "termos": "kds",
    "nomesAlternativos": ["Setores da cozinha", "Destinos KDS"], "recurso": "kds_cozinha"
  },
  {
    "paginaId": "loja/tab/horarios", "id": "funcao-sempre-receber-pedidos",
    "nome": "Sempre receber pedidos", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-clock", "termos": "horários",
    "nomesAlternativos": ["Receber pedidos fora do horário", "Pedidos com loja fechada"]
  },
  {
    "paginaId": "loja/tab/horarios", "id": "funcao-fuso-horario",
    "nome": "Fuso horário", "descricao": "Localize esta opção nas configurações da página.",
    "icone": "fe-clock", "termos": "horários",
    "nomesAlternativos": ["Alterar fuso horário", "Horário da região"]
  }
];
